export enum NavigationSection {
    ABOUT = "about",
    SKILLS = 'skills',
    EXP = 'experience',
}